/**
 * @generated SignedSource<<8dac1edd92010c52ddf74bbf5dc6640c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type messageHelpers_promotion$data = {
  readonly buyerDisplayable: boolean | null;
  readonly code: string | null;
  readonly flatAdjustmentRate: {
    readonly rate: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly promotionMeta: {
    readonly customBannerMessage: boolean | null;
    readonly desktopBannerCta: string | null;
    readonly desktopBannerMessage: string | null;
    readonly mobileBannerCta: string | null;
    readonly mobileBannerMessage: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "messageHelpers_promotion";
};
export type messageHelpers_promotion$key = {
  readonly " $data"?: messageHelpers_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_promotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "messageHelpers_promotion"
};

(node as any).hash = "2835a87da42faa74a83645152e7afc3b";

export default node;
